<span class="field-view-value uuid-text">{{ value || 'Null' }}</span>